import React from 'react'
import { observer } from 'mobx-react-lite'
import { Topic } from './'

const Topics = observer(({ topics }) => {
	if (!topics) return null
	
	return (
		<div className='topics'>
			{topics.map((t, i) => (
				<Topic key={`tpc-${i}`} {...t} />
			))}

			<style jsx>{`
				div {
					padding-right: 2.5rem;
					min-width: 0;
				}
			`}</style>
		</div>
	)
})

export default Topics
